// extracted by mini-css-extract-plugin
export default {"products":"Vu-z","card":"Wu-z","oosMessaging":"Xu-z"};